import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Bitbot = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M13 4.20001C13 4.7523 12.5523 5.20001 12 5.20001C11.4477 5.20001 11 4.7523 11 4.20001C11 3.64773 11.4477 3.20001 12 3.20001C12.5523 3.20001 13 3.64773 13 4.20001Z"
      fill="currentColor"
    />
    <path d="M7 12C6.24056 12 5.625 12.6134 5.625 13.37H8.375C8.375 12.6134 7.75944 12 7 12Z" fill="currentColor" />
    <path d="M12 16.5C13.1045 16.5 14 15.6045 14 14.5H10C10 15.6045 10.8954 16.5 12 16.5Z" fill="currentColor" />
    <path
      d="M16.6269 12C15.8685 12 15.2537 12.6148 15.2537 13.3731H18C18 12.6148 17.3853 12 16.6269 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.76043 6.42355C9.51446 6.12979 14.4127 6.12979 18.1667 6.42355C19.4978 6.52771 20.5592 7.51916 20.8091 8.79927C21.4305 11.9827 21.8075 14.3632 21.9243 17.0152C21.9932 18.581 20.8015 19.8973 19.2454 20C15.1377 20.271 8.78945 20.271 4.68172 20C3.12558 19.8973 1.93388 18.581 2.00285 17.0152C2.11965 14.3632 2.49661 11.9827 3.11809 8.79927C3.368 7.51916 4.42941 6.52771 5.76043 6.42355ZM18.0107 8.41746C14.3605 8.13182 9.56663 8.13182 5.91645 8.41746C5.51168 8.44913 5.16473 8.75376 5.08103 9.18248C4.46596 12.3331 4.11118 14.5995 4.00091 17.1032C3.98014 17.5747 4.33462 17.9728 4.81336 18.0043C8.83343 18.2695 15.0937 18.2695 19.1138 18.0043C19.5925 17.9728 19.947 17.5747 19.9262 17.1032C19.816 14.5995 19.4612 12.3331 18.8461 9.18248C18.7624 8.75376 18.4155 8.44913 18.0107 8.41746Z"
      fill="currentColor"
    />
  </Icon>
));

export default Bitbot;
